import script from "./ChangeOrganizationNameModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeOrganizationNameModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeOrganizationNameModal.vue?vue&type=style&index=0&id=de6f2f96&scoped=true&lang=css"
script.__scopeId = "data-v-de6f2f96"

export default script